var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"text-uppercase font-weight-medium glass-effect-chip",attrs:{"color":_vm.chipColor,"text-color":"black","small":"","label":""}},[_vm._v(" "+_vm._s(_vm.priority)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }